import type { ReactNode } from "react";

import { Info } from "lucide-react";

import { cn } from "@/shared/lib/utils";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/ui/tooltip";

export const InfoTooltip = ({
  children,
  style,
  warning,
  className,
}: {
  children: ReactNode;
  style?: React.CSSProperties;
  warning?: boolean;
  className?: string;
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info
            style={style}
            className={cn(
              "ml-2 max-h-4 min-h-4 min-w-4 max-w-4",
              warning && "stroke-orange-500 text-orange-500",
              className,
            )}
          />
        </TooltipTrigger>
        <TooltipContent>{children}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
